import React from "react";
import PropTypes from "prop-types";
import { getLinkToProject } from "../../common/util/pathUtils";

const SingleColumn = ({ project, showLearnMore }) => {
    const linkToProject = getLinkToProject(project.code);

    return <div className="w-100 con-justify text-left">
					<div className="up">
						<div className="img-cover img-1 w-100">
							<a href={linkToProject}><img src={project.thumbnailImageUrl} /></a>
						</div>
						<div className="py-2 px-30">
							<h6>{project.locationDescription}</h6>
							<h5><a href={linkToProject}>{project.name}</a></h5>
							<p>{project.shortDescription}</p>
						</div>
					</div>
					<div className="down px-30">
						{showLearnMore &&
						<a href={linkToProject} className="btn-primary btn-sml">Learn more</a>
						}
					</div>
				</div>
}

SingleColumn.propTypes = {
    project: PropTypes.object,
    showLearnMore: PropTypes.bool
}

export default SingleColumn;